import { PageRequest } from '@/core/request/PageRequest';
import { InstallmentSituation } from '../AccountPayable/AccountPayable.types';
import { Moment } from 'moment';

export enum Creditor {
  employee = 'domain.enums.creditor_type.employee',
  supplier = 'domain.enums.creditor_type.supplier',
}

export const InstallmentSituationType = {
  [InstallmentSituation.open]: 'Aberto',
  [InstallmentSituation.canceled]: 'Cancelado',
  [InstallmentSituation.settled]: 'Estabelecido',
  [InstallmentSituation.grouped]: 'Agrupado',
};

export enum ForecastPayableOrderColumn {
  documentNumber = 'domain.enums.order_columns_forecast_payable.document_number',
  documentTypeId = 'domain.enums.order_columns_forecast_payable.document_type_id',
  payDay = 'domain.enums.order_columns_forecast_payable.pay_day',
  planAccoutId = 'domain.enums.order_columns_forecast_payable.plan_account_id',
  company = 'domain.enums.order_columns_forecast_payable.company',
  description = 'domain.enums.order_columns_forecast_payable.description',
  situation = 'domain.enums.order_columns_forecast_payable.stuation',
  value = 'domain.enums.order_columns_forecast_payable.value',
}

export enum ForecastPayableFieldOption {
  documentNumber = 'domain.enums.order_columns_forecast_payable.document_number',
  creditor = 'domain.enums.order_columns_forecast_payable.creditor',
  documentTypeId = 'domain.enums.order_columns_forecast_payable.document_type_id',
  payDay = 'domain.enums.order_columns_forecast_payable.pay_day',
  planAccoutId = 'domain.enums.order_columns_forecast_payable.plan_account_id',
  company = 'domain.enums.order_columns_forecast_payable.company',
  description = 'domain.enums.order_columns_forecast_payable.description',
  situation = 'domain.enums.order_columns_forecast_payable.stuation',
  value = 'domain.enums.order_columns_forecast_payable.value',
}

export const ForecastPayableColumnConfig: Record<
  string,
  ForecastPayableOrderColumn
> = {
  [ForecastPayableFieldOption.documentNumber]:
    ForecastPayableOrderColumn.documentNumber,
  [ForecastPayableFieldOption.documentTypeId]:
    ForecastPayableOrderColumn.documentTypeId,
  [ForecastPayableFieldOption.payDay]: ForecastPayableOrderColumn.payDay,
  [ForecastPayableFieldOption.planAccoutId]:
    ForecastPayableOrderColumn.planAccoutId,
  [ForecastPayableFieldOption.company]: ForecastPayableOrderColumn.company,
  [ForecastPayableFieldOption.description]:
    ForecastPayableOrderColumn.description,
  [ForecastPayableFieldOption.situation]: ForecastPayableOrderColumn.situation,
  [ForecastPayableFieldOption.value]: ForecastPayableOrderColumn.value,
};

export interface ForecastPayable {
  id: number;
  companyId: number;
  companyName: string;
  situation: InstallmentSituation;
  description: string;
  documentNumber: string;
  documentTypeId: number;
  payday: number;
  planAccountId: number;
  employee: {
    id: number;
    name: string;
  };
  supplier: {
    id: number;
    name: string;
  };
  value: number;
  bankAccountId?: number;
  costCenterId?: number;
}

export interface ListForecastPayableQuery extends PageRequest {
  search?: string;
  companyId?: number;
  situation?: InstallmentSituation;
  description?: string;
  documentNumber?: string;
  documentTypeId?: number;
  payDay?: number;
  planAccountId?: string;
  creditor?: string;
  value?: number;
  orderColumns?: ForecastPayableOrderColumn;
}

export interface ForecastPayableFormValues {
  description: string;
  documentNumber: string;
  creditor: Creditor;
  companyId: number;
  supplierId: number;
  supplier: string;
  employeeId: number;
  employee: string;
  payday: number;
  documentTypeId: number;
  planAccountId: number;
  value: number;
  bankAccountId?: number;
  costCenterId?: number;
}

export interface ForecastPayableCreateRequest {
  companyId: number;
  description: string;
  documentNumber: string;
  documentTypeId: number;
  payday: number;
  planAccountId: number;
  supplierId?: number;
  employeeId?: number;
  value: number;
  bankAccountId?: number;
  costCenterId?: number;
}

export interface ForecastPayableUpdateRequest {
  id: number;
  companyId: number;
  description: string;
  documentNumber: string;
  documentTypeId: number;
  payday: number;
  planAccountId: number;
  supplierId?: number;
  employeeId?: number;
  value: number;
}

export enum GenerateAccountsPayableIssueDate {
  dueDate = 'domain.enums.generate_accounts_payable_issue_date.due_date',
  currentDate = 'domain.enums.generate_accounts_payable_issue_date.current_date',
}

export enum GenerateAccountPayablePeriodDate {
  weekly = 'domain.enums.forecast_payable_generate_account_payable_period_date.weekly',
  monthly = 'domain.enums.forecast_payable_generate_account_payable_period_date.monthly',
}

export interface ForecastPayableGenerateAccountRequest {
  forecastPayableId: number;
  periodDate: GenerateAccountPayablePeriodDate;
  issueDate: GenerateAccountsPayableIssueDate;
  initialDate: string;
  finalDate: string;
}

export interface GenerateAccountPayableFormValues {
  initialDate: Moment;
  finalDate: Moment;
  issueDate: GenerateAccountsPayableIssueDate;
  periodDate: GenerateAccountPayablePeriodDate;
}
